module.exports = __webpack_public_path__ + "static/ipad-H-3181f3fdf4509c2922b2a850092c62b8.png";